import { DEFAULT_ADBG_COLOR } from "@helper/sectionConstants";

export type ArticleCarouselFooterProps = {
  caption: string;
  credit: string;
  currentSlideCount?: number;
  totalSlideCount?: number;
  sectionColor?: string;
};

export default function ArticleCarouselFooter({
  caption,
  credit,
  currentSlideCount,
  totalSlideCount,
  sectionColor,
}: ArticleCarouselFooterProps) {
  const currentSlide = currentSlideCount ?? 1;
  const totalSlides = totalSlideCount ?? 1;

  return (
    <div
      className="inline-flex gap-2 p-2 w-full"
      style={{
        backgroundColor: sectionColor
          ? sectionColor + "33"
          : DEFAULT_ADBG_COLOR,
      }}
    >
      <div className="w-full font-opensans text-sm font-normal leading-250 gap-3 grid">
        <div className="text-grey-200">{caption}</div>
        <div className="text-grey-500">{credit}</div>
      </div>

      {totalSlides > 1 ? (
        <div
          className="flex w-20 justify-end font-opensans font-bold text-grey-200"
          style={{ zIndex: 1 }}
        >
          <span>
            {currentSlide + 1} <span className="text-grey-200">of</span>{" "}
            {totalSlides}
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
